import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, pluck } from 'rxjs';
import { ManualSubscription } from 'src/app/generated/CrossPoint.License.Server';
import { BasicXpacInfo } from 'src/app/generated/CrossPoint.RemoteXpac.Server';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/angular-core/services/header.service';
import { HeaderTitleProviderBase } from 'src/app/angular-core/components/navigation/header-base/header-title-provider/header-title-provider.class';
import { IPermission } from 'src/app/shared/guards/authorized.guard';
import { OperationEnum } from 'src/app/utils/enums/operation.enums';
import { createInterceptTabChange } from 'src/app/utils/functions/component.functions';
import { TranslateService } from '@ngx-translate/core';
import { SaveSheetService } from 'src/app/angular-core/services/save-sheet.service';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';
import { Store } from '@ngrx/store';
import { selectDevices } from 'src/app/store/selectors/devices.selectors';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { hasValue } from 'src/app/angular-core/utils/functions/common.functions';

@UntilDestroy()
@Component({
  selector: 'xpac-xpac-info',
  templateUrl: './xpac-info.component.html',
  styleUrls: ['./xpac-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpacInfoComponent extends HeaderTitleProviderBase implements OnInit {

  @ViewChild('tabGroup') public tabGroup!: MatTabGroup;

  public isLoading: boolean = true;
  public formGroupXPACInfo: UntypedFormGroup;
  public manualSubscription: ManualSubscription;

  private xpac: BasicXpacInfo;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    headerService: HeaderService,
    private dialog: MatDialog,
    private saveSheetService: SaveSheetService,
    private translate: TranslateService,
    private store: Store<IRemoteXPACPortalState>,
  ) {
    super(headerService)
  }

  public ngOnInit(): void {
    this.initListeners();
  }

  public ngAfterViewChecked(): void {
    this.tabGroup._handleClick = createInterceptTabChange(this.saveSheetService, this.translate, this.dialog, this.tabGroup);
  }

  public agGetRequiredPermissions(): IPermission[] {
    return [
      { type: 'RemoteMaintenance.License', operation: OperationEnum.READ }
    ];
  }

  private initListeners(): void {
    this.route.data
      .pipe(
        pluck('currentDeviceData'),
        filter(Boolean),
        untilDestroyed(this)
      )
      .subscribe((data: BasicXpacInfo) => {
        if (!hasValue(data.deviceId)) {
          this.router.navigate(['service']);
          return;
        }
        else {
          this.xpac = data;
          this.isLoading = false;
          this.setHeaderTitle(this.xpac.storeName ?? this.xpac.deviceId);
          this.cdr.markForCheck();
        }
      });

    this.store.select(selectDevices)
      .pipe(
        filter(hasValue),
        untilDestroyed(this)
      )
      .subscribe((xpacs: BasicXpacInfo[]) => {
        const xpac = xpacs.find(x => x.deviceId === this.xpac.deviceId);
        if (!xpac) {
          return;
        }
        this.xpac = xpac;
        this.setHeaderTitle(this.xpac.storeName ?? this.xpac.deviceId);
        this.cdr.markForCheck();
      })
  }
}